import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import ls from 'localstorage-slim';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { APP_PERMISSIONS, SUPER_USER } from 'src/app/app.constants';
import { AppState } from 'src/app/store';
import {
  AccountStatementsFiltersModel,
  selectActiveAccount
} from '../../../store/selectors/accounts/accounts.selectors';
ls.config.encrypt = true;
@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  privileges: string[] | undefined = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  selectedAccount$: Observable<AccountStatementsFiltersModel>;

  constructor(private store: Store<AppState>) {
    this.selectedAccount$ = this.store.select(selectActiveAccount);
    this.selectedAccount$.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: value => {
        this.privileges = value.selectedAccount
          ? value.selectedAccount?.privileges
          : ['READ_CARDS', 'BLOCK_CARDS'];
      }
    });
  }

  hasPrivilege(privilege: any): boolean {
    return this.privileges?.includes(privilege) && ls.get(SUPER_USER) === false
      ? true
      : false;
  }

  getAppPermissions(): string[] {
    try {
      const permissions = ls.get(APP_PERMISSIONS);
      if (Array.isArray(permissions)) {
        return permissions;
      }
      // If permissions exist but aren't an array, try to parse them
      if (permissions) {
        const parsed = JSON.parse(permissions as string);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      }
      return [];
    } catch (error) {
      console.error('Error getting permissions:', error);
      return [];
    }
  }

  setAppPermissions(permissions: string[]): void {
    if (!Array.isArray(permissions)) {
      console.error('Invalid permissions format:', permissions);
      return;
    }
    ls.set(APP_PERMISSIONS, JSON.stringify(permissions));
  }

  hasPermission(permission: string): boolean {
    if (ls.get(SUPER_USER)) {
      return true;
    }
    const permissions = this.getAppPermissions();
    return Array.isArray(permissions) && permissions.includes(permission);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
